import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./Common/Configurations/AuthContext";
import { TenantProvider } from "./Common/Contexts/TenantContext";
import { BrowserRouter } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <TenantProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </TenantProvider>
  </BrowserRouter>
);